import { validationMixin } from 'vuelidate'

export const validationsMixin = {
	mixins: [validationMixin],
	methods: {
		fieldIsValid (prop) {
			/* eslint-disable no-unused-vars */
			const { $dirty, $error } = this.$v[prop]
			return ($dirty) ? !$error : null
		},
		validateState (prop, formName = 'form') {
		/* eslint-disable no-unused-vars */
		const { $dirty, $error } = this.$v[formName][prop]
		return (this.$v[formName].$dirty && $dirty) ? !$error : null
		},
		fieldsAreValid () {
			if (this.$v.$invalid) {
				this.$v.$touch()
				return false
			}
			return true
		},
		formIsValid (formName = 'form') {
			this.$v[formName].$touch()
			if (this.$v[formName].$invalid) {
				return false
			}
			return true
		},
		getAllErrors (formName = 'form') {
			this.$v[formName].$touch()
			if (this.$v[formName].$invalid) {
				return this.$v[formName].$error
			}
			return null
		}
  	}
}


// WEBPACK FOOTER //
// ./src/mixins/validations.mixin.js